/* eslint-disable react/style-prop-object */
import React from "react";
import { ButtonIcon, Poptip, Table, Typography } from "@optimizely/axiom";
import classNames from "classnames";
import styles from "../AccessManagementUserForm/AccessManagementUserForm.module.scss";
import { UserGroupWithProjectDetails } from "../../../../lib/access-helpers";

/**
 * Lists the groups an admin selected that grant no product access.
 *
 * These cannot appear in AccessDetailsTable, which is keyed by product, so without this they would
 * be invisible after selection — the exact silent failure EPTS-6429 reported. Rendered next to
 * AccessDetailsTable in the selection forms (with `onRemove`) and in the review steps (without).
 *
 * The step-based flows keep the selection form mounted under `display: none` while the review step
 * renders its own copy, so both instances are in the DOM at once. Pass `testId` to give the review
 * instance a distinct selector — otherwise queries match two elements.
 */
export const GroupsWithoutProductAccessList = ({
    className,
    groups,
    onRemove,
    testId = "groups-without-product-access"
}: {
    className?: string;
    groups: UserGroupWithProjectDetails[];
    onRemove?: (group: UserGroupWithProjectDetails) => void;
    testId?: string;
}) => {
    if (!groups.length) {
        return null;
    }

    return (
        <div {...(className && { className })} data-testid={testId} data-cy={testId}>
            <Typography type="body" tag="div" className="push--bottom">
                Group membership (no product access)
            </Typography>
            <div className="push-triple--left">
                <Table density="tight" shouldAddHover={false} style="rule-no-bottom-border" tableLayoutAlgorithm="auto">
                    <Table.THead>
                        <Table.TR>
                            <Table.TH sorting={{}}>Group</Table.TH>
                        </Table.TR>
                    </Table.THead>
                    <Table.TBody>
                        {groups.map((group) => (
                            <Table.TR key={group.id}>
                                <Table.TD>{group.name}</Table.TD>
                                {onRemove && (
                                    <Table.TD>
                                        <Poptip trigger={"mouseenter"} content="Remove Group" isInline>
                                            <ButtonIcon
className={classNames(styles["icon-button"])}
                                                iconName="trash-can"
                                                size="small"
                                                style="plain"
                                                title="Remove Group"
                                                data-testid={`remove-group-without-access-${group.id}`}
                                                onClick={() => onRemove(group)}
                                            />
                                        </Poptip>
                                    </Table.TD>
                                )}
                            </Table.TR>
                        ))}
                    </Table.TBody>
                </Table>
            </div>
        </div>
    );
};

GroupsWithoutProductAccessList.displayName = "GroupsWithoutProductAccessList";
